unit View.Fs_Prod_Produtos.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UConstantes, System.StrUtils, UUtils, UWeb.Enum, UHelperServer,
  UPersonalizacao_Tabela.Interfaces, UPersonalizacao_Tabela, XData.Web.Client;

type
  TFViewFs_Prod_ProdutosList = class(TForm)
    btNew: TButton;
    Fs_Prod_ProdutosDataset: TXDataWebDataSet;
    Fs_Prod_ProdutosDatasetid: TIntegerField;
    Fs_Prod_ProdutosDatasetnome: TStringField;
    Fs_Prod_ProdutosDatasetcodigo_barras: TStringField;
    Fs_Prod_ProdutosDatasetexcluido: TBooleanField;
    Fs_Prod_ProdutosDatasetinclusao: TDateTimeField;
    Fs_Prod_ProdutosDatasetalteracao: TDateTimeField;
    Fs_Prod_ProdutosDatasetexclusao: TDateTimeField;
    Fs_Prod_ProdutosDatasetimagem: TStringField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    cbbProdutoFoto: TComboBox;
    cbbProdutoOrigem: TComboBox;
    edtCategoriaNome: TEdit;
    btnPesquisarCategoria: TButton;
    edtMarcaNome: TEdit;
    btnPesquisarMarca: TButton;
    edtFabricanteNome: TEdit;
    btnPesquisarFabricante: TButton;
    Fs_Prod_ProdutosDatasetcategoria_id: TIntegerField;
    Fs_Prod_ProdutosDatasetmarca_id: TIntegerField;
    Fs_Prod_ProdutosDatasetfabricante_id: TIntegerField;
    Fs_Prod_ProdutosDatasetfoto: TStringField;
    Fs_Prod_ProdutosDatasetorigem: TIntegerField;
    btnSincronizarElasticSearch: TButton;
    XDataWebClientElasticSearch: TXDataWebClient;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure WebFormShow(Sender: TObject);
    [async]
    procedure btnPesquisarCategoriaClick(Sender: TObject); async;
    [async]
    procedure btnPesquisarMarcaClick(Sender: TObject); async;
    [async]
    procedure btnPesquisarFabricanteClick(Sender: TObject); async;
    procedure cbbProdutoFotoChange(Sender: TObject);
    procedure cbbProdutoOrigemChange(Sender: TObject);
    procedure XDataWebClientElasticSearchError(Error: TXDataClientError);
    procedure XDataWebClientElasticSearchLoad(Response: TXDataClientResponse);
    [async]
    procedure btnSincronizarElasticSearchClick(Sender: TObject); async;
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;

    procedure Filtrar;
    function GetFiltro : string;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewFs_Prod_ProdutosList: TFViewFs_Prod_ProdutosList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewFs_Prod_ProdutosList }

procedure TFViewFs_Prod_ProdutosList.btnPesquisarCategoriaClick(
  Sender: TObject);
var
  lBackupTag : Integer;
begin
  lBackupTag := edtCategoriaNome.Tag;
  Await(THelperServer.ChamarConsulta('Categorias', 'Fs_Prod_Categorias', edtCategoriaNome));

  if lBackupTag <> edtCategoriaNome.Tag then
    Filtrar;
end;

procedure TFViewFs_Prod_ProdutosList.btnPesquisarFabricanteClick(
  Sender: TObject);
var
  lBackupTag : Integer;
begin
  lBackupTag := edtFabricanteNome.Tag;
  Await(THelperServer.ChamarConsulta('Fabricantes', 'Fs_Prod_Fabricantes', edtFabricanteNome));

  if lBackupTag <> edtFabricanteNome.Tag then
    Filtrar;
end;

procedure TFViewFs_Prod_ProdutosList.btnPesquisarMarcaClick(Sender: TObject);
var
  lBackupTag : Integer;
begin
  lBackupTag := edtMarcaNome.Tag;
  Await(THelperServer.ChamarConsulta('Marcas', 'Fs_Prod_Marcas', edtMarcaNome));

  if lBackupTag <> edtMarcaNome.Tag then
    Filtrar;
end;

procedure TFViewFs_Prod_ProdutosList.btnSincronizarElasticSearchClick(
  Sender: TObject);
begin
  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja realizar essa operação?')) then
  begin
    TUtils.ChamarDivLoading;
    XDataWebClientElasticSearch.RawInvoke('IService.SincronizarProdutosComElasticSearch', []);
  end;
end;

procedure TFViewFs_Prod_ProdutosList.cbbProdutoFotoChange(Sender: TObject);
begin
  Filtrar;
end;

procedure TFViewFs_Prod_ProdutosList.cbbProdutoOrigemChange(Sender: TObject);
begin
  Filtrar;
end;

procedure TFViewFs_Prod_ProdutosList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewFs_Prod_ProdutosList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewFs_Prod_ProdutosList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewFs_Prod_ProdutosList, AElementID, Result, @AfterCreate);
end;

procedure TFViewFs_Prod_ProdutosList.edSearchKeyDown(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPlugin.FDatasetPlugin.FParametroPersonalizado := 'fulltext=' + edSearch.Text;
    FGridPlugin.Load;
  end;
end;

procedure TFViewFs_Prod_ProdutosList.edSearchKeyUp(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

function TFViewFs_Prod_ProdutosList.GetFiltro: string;
var
  lFiltro : string;
begin
  Result := EmptyStr;

  case cbbProdutoFoto.ItemIndex of
    1 : Result := '(foto ne null)';
    2 : Result := '(foto eq null)';
  end;

  case cbbProdutoOrigem.ItemIndex of
    0 : Result := Result + '';
    else
    begin
      lFiltro := '(origem eq ' + cbbProdutoOrigem.ItemIndex.ToString + ')';
      if Trim(Result).IsEmpty then
        Result := lFiltro
      else
        Result := Result + ' and ' + lFiltro;
    end;
  end;

  if edtCategoriaNome.Tag <> 0 then
  begin
    lFiltro := '(categoria_id eq ' + edtCategoriaNome.Tag.ToString + ')';
    if Trim(Result).IsEmpty then
      Result := lFiltro
    else
      Result := Result + ' and ' + lFiltro;
  end;

  if edtMarcaNome.Tag <> 0 then
  begin
    lFiltro := '(marca_id eq ' + edtMarcaNome.Tag.ToString + ')';
    if Trim(Result).IsEmpty then
      Result := lFiltro
    else
      Result := Result + ' and ' + lFiltro;
  end;

  if edtFabricanteNome.Tag <> 0 then
  begin
    lFiltro := '(fabricante_id eq ' + edtFabricanteNome.Tag.ToString + ')';
    if Trim(Result).IsEmpty then
      Result := lFiltro
    else
      Result := Result + ' and ' + lFiltro;
  end;
end;

procedure TFViewFs_Prod_ProdutosList.Filtrar;
begin
  FGridPlugin.FDatasetPlugin.FFilterPadrao := Trim(GetFiltro);
  FGridPlugin.Load;
end;

procedure TFViewFs_Prod_ProdutosList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.FDatasetPlugin.FParametroPersonalizado := 'fulltext=' + edSearch.Text;
  FGridPlugin.Load;

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewFs_Prod_ProdutosList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewFs_Prod_ProdutosList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;
  RecordBase64 : string;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
  lImagem : TImageControl;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ação' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Fs_Prod_ProdutosDataset.Connection.Model.DefaultSchema.FindEntityType(Fs_Prod_ProdutosDataset.EntitySetName),
      Fs_Prod_ProdutosDataset.CurrentData
    );

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fa fa-edit"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_editar_produto');
  end
  else if WebDBTableControl1.Columns[ACol].Title = 'Imagem' then
  begin
    RecordBase64 := Fs_Prod_ProdutosDataset.FieldByName('imagem').AsString;

    lImagem := TImageControl.Create(nil);
    lImagem.ParentElement := AElement.element;
    lImagem.Width := 75;
    lImagem.Height := 75;
    lImagem.AutoSize := False;

    if (RecordBase64 = '') or (RecordBase64.ToUpper = 'NULL') then
      lImagem.url := 'assets/img/produto_sem_imagem.webp'
    else
      lImagem.url := RecordBase64;
  end;
end;

procedure TFViewFs_Prod_ProdutosList.WebDBTableControl1GetCellClass(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['nome', 'codigo_barras']) of
      0, 1 : AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewFs_Prod_ProdutosList.WebDBTableControl1GetCellData(
  Sender: TObject; ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['excluido']) of
      0:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>'
      end;
    end;
  end;
end;

procedure TFViewFs_Prod_ProdutosList.WebFormCreate(Sender: TObject);
begin
  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('fs_prod_produtos', 'active');
  TUtils.SetValorDicionarioClasses('fs_produtos_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_fs_produtos', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Fs_Prod_ProdutosDataset,
    lcPaginator,
    lbPaginationInfo
  );

  FGridPlugin.FDatasetPlugin.FFilterPadrao := Trim(GetFiltro);
  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'id desc';
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewFs_Prod_ProdutosList.WebFormShow(Sender: TObject);
begin
  if not TUtils.PossuiPermissao(Fs_Prod_ProdutosDataset.EntitySetName.ToLower, TTipoPermissao.INSERIR) then
    btNew.Enabled := False;
end;

procedure TFViewFs_Prod_ProdutosList.XDataWebClientElasticSearchError(
  Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Error.ErrorMessage);
end;

procedure TFViewFs_Prod_ProdutosList.XDataWebClientElasticSearchLoad(
  Response: TXDataClientResponse);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Solicitação adicionada a fila para sincronização!');
end;

procedure TFViewFs_Prod_ProdutosList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.fs_prod_produtos.list.pagination.info');
  btNew := TButton.Create('view.fs_prod_produtos.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.fs_prod_produtos.list.table');
  cbPageSize := TComboBox.Create('view.fs_prod_produtos.list.cbPageSize');
  edSearch := TEdit.Create('view.fs_prod_produtos.list.search');
  lcPaginator := TListControl.Create('view.fs_prod_produtos.list.pagination');
  cbbProdutoFoto := TComboBox.Create('cbbProdutoFoto');
  cbbProdutoOrigem := TComboBox.Create('cbbProdutoOrigem');
  edtCategoriaNome := TEdit.Create('edtCategoriaNome');
  btnPesquisarCategoria := TButton.Create('btnPesquisarCategoria');
  edtMarcaNome := TEdit.Create('edtMarcaNome');
  btnPesquisarMarca := TButton.Create('btnPesquisarMarca');
  edtFabricanteNome := TEdit.Create('edtFabricanteNome');
  btnPesquisarFabricante := TButton.Create('btnPesquisarFabricante');
  btnSincronizarElasticSearch := TButton.Create('btnSincronizarElasticSearch');
  Fs_Prod_ProdutosDataset := TXDataWebDataSet.Create(Self);
  Fs_Prod_ProdutosDatasetid := TIntegerField.Create(Self);
  Fs_Prod_ProdutosDatasetnome := TStringField.Create(Self);
  Fs_Prod_ProdutosDatasetcodigo_barras := TStringField.Create(Self);
  Fs_Prod_ProdutosDatasetexcluido := TBooleanField.Create(Self);
  Fs_Prod_ProdutosDatasetinclusao := TDateTimeField.Create(Self);
  Fs_Prod_ProdutosDatasetalteracao := TDateTimeField.Create(Self);
  Fs_Prod_ProdutosDatasetexclusao := TDateTimeField.Create(Self);
  Fs_Prod_ProdutosDatasetimagem := TStringField.Create(Self);
  Fs_Prod_ProdutosDatasetcategoria_id := TIntegerField.Create(Self);
  Fs_Prod_ProdutosDatasetmarca_id := TIntegerField.Create(Self);
  Fs_Prod_ProdutosDatasetfabricante_id := TIntegerField.Create(Self);
  Fs_Prod_ProdutosDatasetfoto := TStringField.Create(Self);
  Fs_Prod_ProdutosDatasetorigem := TIntegerField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);
  XDataWebClientElasticSearch := TXDataWebClient.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  cbbProdutoFoto.BeforeLoadDFMValues;
  cbbProdutoOrigem.BeforeLoadDFMValues;
  edtCategoriaNome.BeforeLoadDFMValues;
  btnPesquisarCategoria.BeforeLoadDFMValues;
  edtMarcaNome.BeforeLoadDFMValues;
  btnPesquisarMarca.BeforeLoadDFMValues;
  edtFabricanteNome.BeforeLoadDFMValues;
  btnPesquisarFabricante.BeforeLoadDFMValues;
  btnSincronizarElasticSearch.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDataset.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetid.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetnome.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetcodigo_barras.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetexcluido.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetinclusao.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetalteracao.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetexclusao.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetimagem.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetcategoria_id.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetmarca_id.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetfabricante_id.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetfoto.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetorigem.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  XDataWebClientElasticSearch.BeforeLoadDFMValues;
  try
    Name := 'FViewFs_Prod_ProdutosList';
    Width := 695;
    Height := 552;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Imagem';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'Nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_barras';
      Title := 'C'#243'd. Barras';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    cbbProdutoFoto.SetParentComponent(Self);
    cbbProdutoFoto.Name := 'cbbProdutoFoto';
    cbbProdutoFoto.Left := 8;
    cbbProdutoFoto.Top := 408;
    cbbProdutoFoto.Width := 151;
    cbbProdutoFoto.Height := 21;
    cbbProdutoFoto.HeightPercent := 100.000000000000000000;
    cbbProdutoFoto.Text := 'Todos';
    cbbProdutoFoto.WidthPercent := 100.000000000000000000;
    SetEvent(cbbProdutoFoto, Self, 'OnChange', 'cbbProdutoFotoChange');
    cbbProdutoFoto.ItemIndex := 0;
    cbbProdutoFoto.Items.BeginUpdate;
    try
      cbbProdutoFoto.Items.Clear;
      cbbProdutoFoto.Items.Add('Todos');
      cbbProdutoFoto.Items.Add('Com Foto');
      cbbProdutoFoto.Items.Add('Sem Foto');
    finally
      cbbProdutoFoto.Items.EndUpdate;
    end;
    cbbProdutoOrigem.SetParentComponent(Self);
    cbbProdutoOrigem.Name := 'cbbProdutoOrigem';
    cbbProdutoOrigem.Left := 8;
    cbbProdutoOrigem.Top := 435;
    cbbProdutoOrigem.Width := 151;
    cbbProdutoOrigem.Height := 21;
    cbbProdutoOrigem.HeightPercent := 100.000000000000000000;
    cbbProdutoOrigem.Text := 'Todos';
    cbbProdutoOrigem.WidthPercent := 100.000000000000000000;
    SetEvent(cbbProdutoOrigem, Self, 'OnChange', 'cbbProdutoOrigemChange');
    cbbProdutoOrigem.ItemIndex := 0;
    cbbProdutoOrigem.Items.BeginUpdate;
    try
      cbbProdutoOrigem.Items.Clear;
      cbbProdutoOrigem.Items.Add('Todos');
      cbbProdutoOrigem.Items.Add('Banco produtos 1');
      cbbProdutoOrigem.Items.Add('Banco produtos 2');
      cbbProdutoOrigem.Items.Add('Banco Pet Shop');
      cbbProdutoOrigem.Items.Add('Banco Mat. Constru'#231#227'o');
      cbbProdutoOrigem.Items.Add('Banco Auto pe'#231'as');
    finally
      cbbProdutoOrigem.Items.EndUpdate;
    end;
    edtCategoriaNome.SetParentComponent(Self);
    edtCategoriaNome.Name := 'edtCategoriaNome';
    edtCategoriaNome.Left := 8;
    edtCategoriaNome.Top := 462;
    edtCategoriaNome.Width := 120;
    edtCategoriaNome.Height := 22;
    edtCategoriaNome.ChildOrder := 21;
    edtCategoriaNome.Enabled := False;
    edtCategoriaNome.HeightPercent := 100.000000000000000000;
    edtCategoriaNome.WidthPercent := 100.000000000000000000;
    btnPesquisarCategoria.SetParentComponent(Self);
    btnPesquisarCategoria.Name := 'btnPesquisarCategoria';
    btnPesquisarCategoria.Left := 129;
    btnPesquisarCategoria.Top := 462;
    btnPesquisarCategoria.Width := 30;
    btnPesquisarCategoria.Height := 22;
    btnPesquisarCategoria.ChildOrder := 22;
    btnPesquisarCategoria.HeightPercent := 100.000000000000000000;
    btnPesquisarCategoria.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarCategoria, Self, 'OnClick', 'btnPesquisarCategoriaClick');
    edtMarcaNome.SetParentComponent(Self);
    edtMarcaNome.Name := 'edtMarcaNome';
    edtMarcaNome.Left := 8;
    edtMarcaNome.Top := 490;
    edtMarcaNome.Width := 120;
    edtMarcaNome.Height := 22;
    edtMarcaNome.ChildOrder := 21;
    edtMarcaNome.Enabled := False;
    edtMarcaNome.HeightPercent := 100.000000000000000000;
    edtMarcaNome.WidthPercent := 100.000000000000000000;
    btnPesquisarMarca.SetParentComponent(Self);
    btnPesquisarMarca.Name := 'btnPesquisarMarca';
    btnPesquisarMarca.Left := 129;
    btnPesquisarMarca.Top := 490;
    btnPesquisarMarca.Width := 30;
    btnPesquisarMarca.Height := 22;
    btnPesquisarMarca.ChildOrder := 22;
    btnPesquisarMarca.HeightPercent := 100.000000000000000000;
    btnPesquisarMarca.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarMarca, Self, 'OnClick', 'btnPesquisarMarcaClick');
    edtFabricanteNome.SetParentComponent(Self);
    edtFabricanteNome.Name := 'edtFabricanteNome';
    edtFabricanteNome.Left := 8;
    edtFabricanteNome.Top := 517;
    edtFabricanteNome.Width := 120;
    edtFabricanteNome.Height := 22;
    edtFabricanteNome.ChildOrder := 21;
    edtFabricanteNome.Enabled := False;
    edtFabricanteNome.HeightPercent := 100.000000000000000000;
    edtFabricanteNome.WidthPercent := 100.000000000000000000;
    btnPesquisarFabricante.SetParentComponent(Self);
    btnPesquisarFabricante.Name := 'btnPesquisarFabricante';
    btnPesquisarFabricante.Left := 129;
    btnPesquisarFabricante.Top := 517;
    btnPesquisarFabricante.Width := 30;
    btnPesquisarFabricante.Height := 22;
    btnPesquisarFabricante.ChildOrder := 22;
    btnPesquisarFabricante.HeightPercent := 100.000000000000000000;
    btnPesquisarFabricante.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarFabricante, Self, 'OnClick', 'btnPesquisarFabricanteClick');
    btnSincronizarElasticSearch.SetParentComponent(Self);
    btnSincronizarElasticSearch.Name := 'btnSincronizarElasticSearch';
    btnSincronizarElasticSearch.Left := 176;
    btnSincronizarElasticSearch.Top := 406;
    btnSincronizarElasticSearch.Width := 137;
    btnSincronizarElasticSearch.Height := 25;
    btnSincronizarElasticSearch.Caption := 'Sincronizar ElasticSearch';
    btnSincronizarElasticSearch.ChildOrder := 14;
    btnSincronizarElasticSearch.HeightPercent := 100.000000000000000000;
    btnSincronizarElasticSearch.WidthPercent := 100.000000000000000000;
    SetEvent(btnSincronizarElasticSearch, Self, 'OnClick', 'btnSincronizarElasticSearchClick');
    Fs_Prod_ProdutosDataset.SetParentComponent(Self);
    Fs_Prod_ProdutosDataset.Name := 'Fs_Prod_ProdutosDataset';
    Fs_Prod_ProdutosDataset.EntitySetName := 'Fs_Prod_Produtos';
    Fs_Prod_ProdutosDataset.Connection := DMConnection.ApiConnection;
    Fs_Prod_ProdutosDataset.Left := 72;
    Fs_Prod_ProdutosDataset.Top := 144;
    Fs_Prod_ProdutosDatasetid.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetid.Name := 'Fs_Prod_ProdutosDatasetid';
    Fs_Prod_ProdutosDatasetid.FieldName := 'id';
    Fs_Prod_ProdutosDatasetid.Required := True;
    Fs_Prod_ProdutosDatasetnome.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetnome.Name := 'Fs_Prod_ProdutosDatasetnome';
    Fs_Prod_ProdutosDatasetnome.FieldName := 'nome';
    Fs_Prod_ProdutosDatasetnome.Required := True;
    Fs_Prod_ProdutosDatasetnome.Size := 255;
    Fs_Prod_ProdutosDatasetcodigo_barras.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetcodigo_barras.Name := 'Fs_Prod_ProdutosDatasetcodigo_barras';
    Fs_Prod_ProdutosDatasetcodigo_barras.FieldName := 'codigo_barras';
    Fs_Prod_ProdutosDatasetcodigo_barras.Required := True;
    Fs_Prod_ProdutosDatasetcodigo_barras.Size := 255;
    Fs_Prod_ProdutosDatasetexcluido.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetexcluido.Name := 'Fs_Prod_ProdutosDatasetexcluido';
    Fs_Prod_ProdutosDatasetexcluido.FieldName := 'excluido';
    Fs_Prod_ProdutosDatasetinclusao.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetinclusao.Name := 'Fs_Prod_ProdutosDatasetinclusao';
    Fs_Prod_ProdutosDatasetinclusao.FieldName := 'inclusao';
    Fs_Prod_ProdutosDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Fs_Prod_ProdutosDatasetalteracao.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetalteracao.Name := 'Fs_Prod_ProdutosDatasetalteracao';
    Fs_Prod_ProdutosDatasetalteracao.FieldName := 'alteracao';
    Fs_Prod_ProdutosDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Fs_Prod_ProdutosDatasetexclusao.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetexclusao.Name := 'Fs_Prod_ProdutosDatasetexclusao';
    Fs_Prod_ProdutosDatasetexclusao.FieldName := 'exclusao';
    Fs_Prod_ProdutosDatasetexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Fs_Prod_ProdutosDatasetimagem.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetimagem.Name := 'Fs_Prod_ProdutosDatasetimagem';
    Fs_Prod_ProdutosDatasetimagem.FieldName := 'imagem';
    Fs_Prod_ProdutosDatasetimagem.Size := 0;
    Fs_Prod_ProdutosDatasetcategoria_id.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetcategoria_id.Name := 'Fs_Prod_ProdutosDatasetcategoria_id';
    Fs_Prod_ProdutosDatasetcategoria_id.FieldName := 'categoria_id';
    Fs_Prod_ProdutosDatasetmarca_id.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetmarca_id.Name := 'Fs_Prod_ProdutosDatasetmarca_id';
    Fs_Prod_ProdutosDatasetmarca_id.FieldName := 'marca_id';
    Fs_Prod_ProdutosDatasetfabricante_id.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetfabricante_id.Name := 'Fs_Prod_ProdutosDatasetfabricante_id';
    Fs_Prod_ProdutosDatasetfabricante_id.FieldName := 'fabricante_id';
    Fs_Prod_ProdutosDatasetfoto.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetfoto.Name := 'Fs_Prod_ProdutosDatasetfoto';
    Fs_Prod_ProdutosDatasetfoto.FieldName := 'foto';
    Fs_Prod_ProdutosDatasetfoto.Size := 255;
    Fs_Prod_ProdutosDatasetorigem.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetorigem.Name := 'Fs_Prod_ProdutosDatasetorigem';
    Fs_Prod_ProdutosDatasetorigem.FieldName := 'origem';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Fs_Prod_ProdutosDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 392;
    tmrConsulta.Top := 232;
    XDataWebClientElasticSearch.SetParentComponent(Self);
    XDataWebClientElasticSearch.Name := 'XDataWebClientElasticSearch';
    XDataWebClientElasticSearch.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebClientElasticSearch, Self, 'OnLoad', 'XDataWebClientElasticSearchLoad');
    SetEvent(XDataWebClientElasticSearch, Self, 'OnError', 'XDataWebClientElasticSearchError');
    XDataWebClientElasticSearch.Left := 422;
    XDataWebClientElasticSearch.Top := 427;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    cbbProdutoFoto.AfterLoadDFMValues;
    cbbProdutoOrigem.AfterLoadDFMValues;
    edtCategoriaNome.AfterLoadDFMValues;
    btnPesquisarCategoria.AfterLoadDFMValues;
    edtMarcaNome.AfterLoadDFMValues;
    btnPesquisarMarca.AfterLoadDFMValues;
    edtFabricanteNome.AfterLoadDFMValues;
    btnPesquisarFabricante.AfterLoadDFMValues;
    btnSincronizarElasticSearch.AfterLoadDFMValues;
    Fs_Prod_ProdutosDataset.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetid.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetnome.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetcodigo_barras.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetexcluido.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetinclusao.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetalteracao.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetexclusao.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetimagem.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetcategoria_id.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetmarca_id.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetfabricante_id.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetfoto.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetorigem.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
    XDataWebClientElasticSearch.AfterLoadDFMValues;
  end;
end;

end.
